import React from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import Layout from "../components/Layout";

export default function BasePage() {
  const navigate = useNavigate();

  // Removed manual auth check as it's now handled by RequireAuth wrapper in App.js
  // This prevents premature redirection during Firebase initialization.


  return (
    <Layout>
      <div className="layout-content" style={{ maxWidth: 600, margin: "0 auto" }}>
        {/* HEADER SECTION */}
        <div style={{ marginBottom: 40, textAlign: "center" }}>
            <h1 style={{ fontSize: 32, fontWeight: 900, marginBottom: 8, letterSpacing: "-0.03em" }}>Field Command</h1>
            <p style={{ color: "var(--text-muted)", fontSize: 16 }}>Operational nexus for field agents and distributor nodes.</p>
        </div>

        {/* PRIMARY ACTIONS */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 40 }}>
            <button 
                onClick={() => navigate("/distributor-order")}
                className="btn-primary"
                style={{ height: 160, borderRadius: 24, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 16, fontSize: 14, fontWeight: 800 }}
            >
                <div style={{ fontSize: 40 }}>📦</div>
                INVENTORY ORDER
            </button>
            <button 
                onClick={() => navigate("/cashier")}
                className="btn-primary"
                style={{ height: 160, borderRadius: 24, background: "var(--success)", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 16, fontSize: 14, fontWeight: 800, border: "none" }}
            >
                <div style={{ fontSize: 40 }}>💰</div>
                CASH COLLECTION
            </button>
        </div>

        {/* INFORMATION NODES */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 24 }}>
            {/* SCHEMES */}
            <div className="premium-card" style={{ padding: 24 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                    <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>📢 Critical Schemes</h3>
                    <div className="badge badge-warning" style={{ fontSize: 10 }}>MARCH 2026 ACTIVE</div>
                </div>
                <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12 }}>
                    {[
                        "Standard Q3 Rebate Active (+2.5%)",
                        "High Volume SKU Liquidation Bonus",
                        "New Retailer Onboarding Incentives"
                    ].map((item, idx) => (
                        <li key={idx} style={{ padding: "12px 16px", background: "var(--surface-hover)", borderRadius: 12, fontSize: 14, fontWeight: 500, display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ width: 6, height: 6, background: "var(--primary)", borderRadius: "50%" }}></div>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>

            {/* PERFORMANCE / EARNINGS */}
            <div className="premium-card" style={{ padding: 24, background: "linear-gradient(135deg, var(--surface) 0%, rgba(255, 107, 0, 0.05) 100%)" }}>
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800, marginBottom: 20 }}>💰 Liquidity Snapshot</h3>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                    {[
                        { label: "Base Commission", value: "₹ 12,450" },
                        { label: "Performance Bonus", value: "₹ 4,300" },
                        { label: "Scheme Incentives", value: "₹ 1,200" },
                        { label: "Total Pay-run", value: "₹ 17,950", highlighted: true }
                    ].map((item, idx) => (
                        <div key={idx} style={{ padding: 16, background: "var(--surface)", borderRadius: 16, border: "1px solid var(--border)" }}>
                            <div style={{ fontSize: 10, fontWeight: 800, color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 4 }}>{item.label}</div>
                            <div style={{ fontSize: 18, fontWeight: 900, color: item.highlighted ? "var(--primary)" : "var(--text-main)" }}>{item.value}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* HALL OF FAME */}
            <div className="premium-card" style={{ padding: 32, textAlign: "center", border: "2px solid gold", background: "radial-gradient(circle at center, rgba(255, 215, 0, 0.05) 0%, transparent 100%)" }}>
                <div style={{ marginBottom: 20 }}>
                     <span className="badge" style={{ background: "gold", color: "#000", fontWeight: 900 }}>🏆 ELITE PERFORMER</span>
                </div>
                
                <div style={{ position: "relative", width: 120, height: 120, margin: "0 auto 20px" }}>
                    <img 
                        src="https://picsum.photos/200" 
                        alt="Winner" 
                        style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", border: "4px solid gold", boxShadow: "0 0 30px rgba(255, 215, 0, 0.3)" }} 
                    />
                    <div style={{ position: "absolute", bottom: -5, right: -5, background: "gold", color: "#000", width: 32, height: 32, borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", fontSize: 18, fontWeight: 900, boxShadow: "0 5px 15px rgba(0,0,0,0.2)" }}>1</div>
                </div>

                <h3 style={{ margin: 0, fontSize: 24, fontWeight: 900 }}>Arjun Sharma</h3>
                <p style={{ color: "var(--text-muted)", fontSize: 14, marginTop: 4 }}>North Hub Distribution Core</p>
                
                <div style={{ marginTop: 24, padding: "12px 24px", borderRadius: 40, background: "rgba(16, 185, 129, 0.1)", color: "var(--success)", display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 700, fontSize: 13 }}>
                    <div style={{ width: 8, height: 8, background: "var(--success)", borderRadius: "50%" }}></div>
                    RECORD REVENUE GENERATED THIS FISCAL
                </div>
            </div>
        </div>

        {/* SYSTEM STATUS FOOTER */}
        <div style={{ marginTop: 60, textAlign: "center", opacity: 0.3 }}>
            <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: "0.1em", textTransform: "uppercase" }}>QuickBill Distributed Ledger Protocol v2.1</div>
        </div>
      </div>
    </Layout>
  );
}
